import { Flex } from "../../common"

const CommentSection = props => {
  const { author, content } = props

  return (
    <Flex align="normal" gap="6px" vertical>
      {author}
      {content}
    </Flex>
  )
}

export default CommentSection
